<template>
  <page title="余额查询">
    <div v-show="accountType != 0">
      <div class="form balance">
        <mt-field label="结余时间：" class="mt-gap" v-model="search.queryDate" @click.native="openPicker" readonly="">
          <img src="../assets/date.png" alt="" class="input-icon">
        </mt-field>
        <div style="background-color: #fff;padding: 10px 10px 10px;color: #666;font-size: 14px;overflow: hidden;" class="borderTop">
          <p v-for="(item,index) in result" :key="index">{{item.currency}} <span style="color: red;" class="fr">{{item.money}}</span></p>
        </div>
      </div>
      <div v-if="initSearch&&result.length === 0">
        <p style="text-align: center;margin-top: 10px;color: #999;font-size: 14px;">没有数据</p>
      </div>
      <mt-datetime-picker
              ref="picker"
              v-model="datePicker"
              type="date"
              @confirm="handleConfirm1">
      </mt-datetime-picker>
    </div>
  </page>
</template>
<script>
    export default {
        data() {
            return {
                accountType: '',
                datePicker:'',
                search: {
                    queryDate: ''
                },
                result: [],
                initSearch: false,
            }
        },
        created() {
            document.title="余额查询";
            let companyNo = this.$util.get('companyNo');
            this.accountType = this.$util.get(companyNo+'_userInfo').accountType;
            if (this.accountType!=0){
                var date = new Date();
                this.datePicker = date;
                this.search.queryDate = this.dateFormat(date);
                this.searchData();
            } else {
                this.$toast("此功能只针对客户账号开放");
            }

        },
        methods: {
            openPicker() {
                this.$refs.picker.open();
            },
            handleConfirm1() {
                var date = this.datePicker;
                this.search.queryDate = this.dateFormat(date);
                this.searchData();
            },
            dateFormat(date) {
                var year = date.getFullYear();
                var month = date.getMonth()+1;
                if (month < 10) {
                    month = '0'+month;
                }
                var day = date.getDate();
                if (day < 10) {
                    day = '0'+day;
                }
                return year+'-'+month+'-'+day;
            },
            searchData() {
                this.$indicator.open({
                    spinnerType: 'fading-circle'
                });
                this.http.send({command:'customerBalance/queryBalance',params: this.search}).then(res => {
                    this.initSearch = true;
                    this.$indicator.close();
                    this.result = res.data.body || [];
                })
            }
        }
    }
</script>
<style scoped>
  .balance >>> .mint-field-core {
    text-align: right;
  }
</style>
<style>
  .borderTop {
    background-image: linear-gradient(180deg, #d9d9d9, #d9d9d9 50%, transparent 50%);
    background-size: 120% 1px;
    background-repeat: no-repeat;
    background-position: top left;
  }
</style>



// WEBPACK FOOTER //
// src/page/balance.vue